import React from 'react';
import { Col, Form } from 'react-bootstrap';

const FormSelect = ({
      classes,
      title,
      required,
      setData,
      loading,
      options,
      selected,
      selectNone,
      order
}) => {
      return (
            <>
                  <Col lg={classes ? classes : 6}>
                        <Form.Label>
                              {title}{' '}
                              {required && (
                                    <span className="text-danger">*</span>
                              )}
                        </Form.Label>
                        <Form.Select
                              value={selected}
                              onChange={
                                    order
                                          ? (event) =>
                                                  setData(
                                                        order,
                                                        event.target.value
                                                  )
                                          : (event) =>
                                                  setData(event.target.value)
                              }
                        >
                              <option value="">Select One</option>
                              {selectNone && (
                                    <option value="none">Without brand</option>
                              )}
                              {!loading ? (
                                    options.length > 0 ? (
                                          options.map((option, index) => (
                                                <option
                                                      key={index}
                                                      value={option.id}
                                                >
                                                      {option.title}
                                                </option>
                                          ))
                                    ) : (
                                          <option value="">
                                                No data found
                                          </option>
                                    )
                              ) : (
                                    <option value="">Loading</option>
                              )}
                        </Form.Select>
                  </Col>
            </>
      );
};

export default FormSelect;
